export function getUrl(path: string) {
    if (path.startsWith('http')) {
        return path;
    }
    return `${process.env.NEXT_CONFIG_BASE_PATH || ''}${path}`;
}

export function getKromaticSiteOriginForHost(hostname?: string | null): string | null {
    const host = (hostname || '').toLowerCase();

    if (host === 'staging.kromatic.com') {
        return 'https://staging.kromatic.com';
    }

    if (host === 'kromatic.com' || host === 'www.kromatic.com') {
        return 'https://kromatic.com';
    }

    return null;
}

export function resolveKromaticSiteUrl(url: string, runtimeHostname?: string): string {
    if (!url) {
        return url;
    }

    let parsed: URL;
    try {
        parsed = new URL(url);
    } catch {
        return url;
    }

    const host = parsed.hostname.toLowerCase();
    const isKnownKromaticHost =
        host === 'kromatic.com' || host === 'www.kromatic.com' || host === 'staging.kromatic.com';
    if (!isKnownKromaticHost) {
        return url;
    }

    const resolvedOrigin = getKromaticSiteOriginForHost(
        runtimeHostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')
    );
    if (!resolvedOrigin) {
        return url;
    }

    const target = new URL(resolvedOrigin);
    parsed.protocol = target.protocol;
    parsed.host = target.host;
    return parsed.toString();
}
